// frontend/src/components/approver/ApproverDashboard.tsx - WITH CHANGE PASSWORD
import React, { useState, useCallback, useMemo } from 'react';
import { AuthUser } from '../../services/auth.service';
import ApproverHeader from './ApproverHeader';
import ApproverSidebar from './ApproverSidebar';
import ApproverMainContent from './ApproverMainContent';
import ChangePassword from '../auth/ChangePassword'; // ADD THIS IMPORT
import styles from './ApproverDashboard.module.css';

interface ApproverDashboardProps {
  user: AuthUser;
  onLogout: () => void;
}

const ApproverDashboard: React.FC<ApproverDashboardProps> = ({ user, onLogout }) => {
  const [activePage, setActivePage] = useState('dashboard');
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false); // ADD THIS STATE

  console.log('🔐 Approver Dashboard rendering for:', user.name);

  // Navigation handler
  const handlePageChange = useCallback((pageId: string, params?: string) => {
    if (isTransitioning) return;

    console.log('🧭 Approver Dashboard: Navigating to page:', pageId, params);
    
    setIsTransitioning(true);
    setActivePage(pageId);
    
    setTimeout(() => {
      setIsTransitioning(false);
    }, 150);
  }, [isTransitioning]);

  // Sidebar toggle handler
  const handleSidebarToggle = useCallback((collapsed: boolean) => {
    setIsSidebarCollapsed(collapsed);
  }, []);

  // ADD THIS HANDLER - Change Password
  const handleChangePassword = useCallback(() => {
    console.log('📝 Approver Dashboard: Opening Change Password modal');
    setShowChangePassword(true);
  }, []);

  // ADD THIS HANDLER - Close Change Password
  const handleCloseChangePassword = useCallback(() => {
    console.log('📝 Approver Dashboard: Closing Change Password modal');
    setShowChangePassword(false);
  }, []);

  // Memoized props for performance
  const sidebarProps = useMemo(() => ({
    activePage,
    onPageChange: handlePageChange,
    isTransitioning,
    onToggle: handleSidebarToggle,
    user
  }), [activePage, handlePageChange, isTransitioning, handleSidebarToggle, user]);

  const mainContentProps = useMemo(() => ({
    activePage,
    onNavigate: handlePageChange,
    isTransitioning,
    isSidebarCollapsed,
    user
  }), [activePage, handlePageChange, isTransitioning, isSidebarCollapsed, user]);

  // UPDATE THIS - Add onChangePassword prop
  const headerProps = useMemo(() => ({
    user,
    onLogout,
    onNavigate: handlePageChange,
    onChangePassword: handleChangePassword // ADD THIS
  }), [user, onLogout, handlePageChange, handleChangePassword]);

  return (
    <div className={styles.approverDashboardContainer}>
      {/* Approver Header */}
      <ApproverHeader {...headerProps} />
      
      {/* Main Dashboard Body */}
      <div className={styles.approverDashboardBody}>
        {/* Sidebar */}
        <ApproverSidebar {...sidebarProps} />
        
        {/* Main Content Area */}
        <ApproverMainContent {...mainContentProps} />
      </div>

      {/* ADD THIS - Change Password Modal */}
      {showChangePassword && (
        <ChangePassword 
          user={user} 
          onClose={handleCloseChangePassword} 
        />
      )}
    </div>
  );
};

export default React.memo(ApproverDashboard);